import * as _ from 'lodash';

import {
    AmendNameAddressRequest, ContractAmendmentDetails, Name
} from '../../Models/ContractAmendment/AmendNameAddressRequest';
import { Address } from '../../Models/Customer/Address';
import * as Services from '../../Services';

export class AmendNameAddressCtrl {
  private currentAddress: Address;
  private currentName: Name;
  private currentTrustName: string;
  private currentIsInTrust: boolean;
  private updateRequest: AmendNameAddressRequest;
  private igsCustomerNumber: string;
  private contractAmendmentInProgress: boolean;
  private hasSignedEConsent: boolean;
  private hasSignedContract: boolean;
  private hasDocumentsInProgress: boolean;

  public static $inject = ["ngToast", "UserService", "$state", "ContractAmendmentApiClient", "DocusignApiClient"];

  constructor(
    private ngToast: any,
    private userService: Services.UserService.IUserService,
    private $state: angular.ui.IStateService,
    private contractAmendmentApiClient: Services.ContractAmendmentApiClient.IContractAmendmentApiClient,
    private docusignApiClient: Services.DocusignApiClient.IDocusignApiClient,
  ) {
    this.igsCustomerNumber = this.$state.params["igsCustomerNumber"];
    this.updateRequest = new AmendNameAddressRequest();
    this.updateRequest.contractAmendmentDetails = new ContractAmendmentDetails();
    this.updateRequest.igsCustomerNumber = this.igsCustomerNumber;
    this.docusignApiClient = docusignApiClient;

    this.getCurrentCustomerDetails();
  }

  public returnToCustomerProfile = (): void => {
    this.$state.go("main.customerv2", { igsCustomerNumber: this.igsCustomerNumber });
  };

  public submitAmendment = (): void => {
    this.contractAmendmentApiClient.submitContractAmendment(this.updateRequest).then(() => {
      this.returnToCustomerProfile();
    });
  };

  public cancelAmendment = (): void => {
    this.docusignApiClient.syncCustomerWithDocusign(this.igsCustomerNumber).then(() => {
      this.contractAmendmentApiClient.cancelContractAmendment(this.igsCustomerNumber).then(() => {
        this.getCurrentCustomerDetails();
      });
    });
  };

  public displayDocusignWarning = (): boolean => {
    //once a customer has signed the econsent, any name updates will send a new one to be signed
    //any changes post-contract signing requires new docs to be signed
    if ((this.updateRequest.contractAmendmentDetails.amendName && this.hasSignedEConsent) || this.hasSignedContract)
      return true;

    return false;
  };

  public detailsHaveChanged = (): boolean => {
    if (!this.currentName) {
      return false;
    }

    if (
      this.nameDetailsHaveChanged() &&
      this.addressDetailsHaveChanged() &&
      this.trustDetailsHaveChanged() &&
      (this.updateRequest.contractAmendmentDetails.amendName ||
        this.updateRequest.contractAmendmentDetails.amendAddress ||
        this.updateRequest.contractAmendmentDetails.amendTrust)
    )
      return true;

    return false;
  };

  public nameDetailsHaveChanged = (): boolean => {
    if (
      this.updateRequest.contractAmendmentDetails.amendName &&
      this.currentName.firstName === this.updateRequest.contractAmendmentDetails.name.firstName &&
      this.currentName.lastName === this.updateRequest.contractAmendmentDetails.name.lastName &&
      this.currentName.middleName === this.updateRequest.contractAmendmentDetails.name.middleName
    )
      return false;

    return true;
  };

  public addressDetailsHaveChanged = (): boolean => {
    if (
      this.updateRequest.contractAmendmentDetails.amendAddress &&
      this.currentAddress.addressLine1 === this.updateRequest.contractAmendmentDetails.address.addressLine1 &&
      this.currentAddress.addressLine2 === this.updateRequest.contractAmendmentDetails.address.addressLine2 &&
      this.currentAddress.city === this.updateRequest.contractAmendmentDetails.address.city &&
      this.currentAddress.zipCode === this.updateRequest.contractAmendmentDetails.address.zipCode
    )
      return false;

    return true;
  };

  public trustDetailsHaveChanged = (): boolean => {
    if (
      this.updateRequest.contractAmendmentDetails.amendTrust &&
      this.currentTrustName === this.updateRequest.contractAmendmentDetails.trustName &&
      this.currentIsInTrust === this.updateRequest.contractAmendmentDetails.isInTrust
    )
      return false;

    return true;
  };

  public getCurrentCustomerDetails = (): void => {
    this.contractAmendmentApiClient
      .getCurrentDetails(this.igsCustomerNumber)
      .then((contractAmendmentCustomerDetails) => {
        this.currentAddress = contractAmendmentCustomerDetails.originalAddress;
        this.currentName = contractAmendmentCustomerDetails.originalName;
        this.currentTrustName = contractAmendmentCustomerDetails.originalTrustName;
        this.currentIsInTrust = contractAmendmentCustomerDetails.originalTrustName ? true : false;
        this.hasSignedContract = contractAmendmentCustomerDetails.customerHasSignedContract;
        this.hasSignedEConsent = contractAmendmentCustomerDetails.customerHasSignedElectronicConsent;
        this.hasDocumentsInProgress = contractAmendmentCustomerDetails.documentsInProgress;

        if (contractAmendmentCustomerDetails.contractAmendmentInProgress) {
          this.updateRequest.contractAmendmentDetails =
            contractAmendmentCustomerDetails.currentContractAmendmentDetails;
          this.contractAmendmentInProgress = true;
        } else {
          this.updateRequest.contractAmendmentDetails.address = Address.createNewAddress(this.currentAddress);
          this.updateRequest.contractAmendmentDetails.name = Name.createNewName(this.currentName);
          this.updateRequest.contractAmendmentDetails.trustName = this.currentTrustName;
          this.updateRequest.contractAmendmentDetails.isInTrust = contractAmendmentCustomerDetails.originalIsInTrust;
          this.updateRequest.contractAmendmentDetails.amendAddress = false;
          this.updateRequest.contractAmendmentDetails.amendName = false;
          this.updateRequest.contractAmendmentDetails.amendTrust = false;
          this.contractAmendmentInProgress = false;
        }
      });
  };
}
